<template>
  <router-view/>
</template>

<script>
export default {
  name: "Statistik"
}
</script>

<style>

</style>
